// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"ea3a8012","845":"01a574f7"}[chunkId] + ".chunk.js";
};